import './PanicButton.css';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import { useAsgActions } from '../../../../../shared/src/hooks/use-asg-actions.hook';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import { useDeviceTypeHook } from '../../../../../shared/src/hooks/use-device-type.hook';

export const PanicButton = ({
    className = '',
}) => {
    const { t } = useTranslations();
    const { renderPanicButton } = useAsgActions();
    const dispatch = useDispatch();
    const { isMobile } = useDeviceTypeHook();
    const containerId = 'game-page-panic-button-target';

    useEffect(() => {
        dispatch(renderPanicButton({
            selector: `#${containerId}`,
            text: t('germanPanicButtonText'),
        }));
    }, []);

    const wrapperClass = classNames(
        className,
        'game-page-panic-button',
        {
            'game-page-panic-button--mobile': isMobile,
            'game-page-panic-button--desktop': !isMobile,
        }
    );

    return (
        <div className={wrapperClass}>
            <div id={containerId} />
        </div>
    );
};
